import { Action } from './toast-types';
import { BaseToastStrategy } from './toast-message-strategy';
export class AppointmentToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Appointment';
    }
}
export class ClientToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Client';
    }
}
export class PetToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Pet';
    }
}
export class ServiceToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Service';
    }
}
export class UserToastStrategy extends BaseToastStrategy {
    getName() {
        return 'User';
    }
}
export class WorkingHoursToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Working hours';
    }
}
export class TeamMemberInvitationToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Invitation';
    }
    getSuccessMessage(action) {
        if (action === Action.Delete) {
            return {
                title: 'Success!',
                message: 'Invitation revoked successfully.',
            };
        }
        return {
            title: 'Success!',
            message: 'Invitation sent successfully.',
        };
    }
    getErrorMessage(action) {
        if (action === Action.Delete) {
            return {
                title: 'Error!',
                message: 'Failed to revoke invitation.',
            };
        }
        return {
            title: 'Error!',
            message: 'Failed to send invitation.',
        };
    }
}
export class ServiceVariantToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Service variant';
    }
}
export class TeamMemberToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Team member';
    }
}
export class LocationToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Location';
    }
}
export class SizeCategoryToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Size';
    }
}
export class CoatTypeToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Coat type';
    }
}
export class SupportTicketToastStrategy extends BaseToastStrategy {
    getName() {
        return 'Support ticket';
    }
    getSuccessMessage(action) {
        if (action === Action.Create) {
            return {
                title: 'Support ticket submitted!',
                message: "We've received your message and will be in touch shortly.",
            };
        }
        return {
            title: 'Success!',
            message: 'Support ticket updated successfully.',
        };
    }
}
